require('./periodicLoadsTableRow.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { withRouter } = require('react-router-dom');

// @core
const { FormattedText, getLanguage, formatText } = require('core/i18n').i18n;

// @utilities
const { formatCurrency, getFormattedString } = require('utilities/currencyHelper');

// @commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKCollapsingToggler } = require('commonsComponents/OKCollapsingToggler');
const { LabelDate } = require('commonsComponents/labelDate');
const { OKIconButton } = require('commonsComponents/OKIconButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const { EURO_TEXT, DATE_FOR_INFINITE }= require('constants/index');
const { PERIODICITY } = require('constants/cardPeriodicLoads');


class PeriodicLoadsTableRow extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            rowId : ''
        }
        this.handleEditPeriodicLoads = this.handleEditPeriodicLoads.bind(this);
        this.handleDeletePeriodicLoads = this.handleDeletePeriodicLoads.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
    }

    handleEditPeriodicLoads() {
        const {
            history,
            immTransaction
        } = this.props;
        const scheduleTransferId = immTransaction.get('scheduleTransferId');
        const currentUrl = `${window.location.pathname}/${scheduleTransferId}/edit-periodic-load`;
        history.push(`${currentUrl}`);
    }

    handleDeletePeriodicLoads() {
        const {
            history,
            immTransaction
        } = this.props;
        const scheduleTransferId = immTransaction.get('scheduleTransferId');
        const currentUrl = `${window.location.pathname}/delete-periodic-load/${scheduleTransferId}`;
        history.push(`${currentUrl}`);
    }

    onRowClick() {
        const { id, onRowClick } = this.props;
        onRowClick(id);
    }

    buildActionButtons() {
        const editButton =  (
            <div className="periodic-loads-table-row__edit-button">
                <OKIconButton icon="icon-editar" onClick={this.handleEditPeriodicLoads}/>
            </div>
        );
        const deleteButton = (
            <div className="periodic-loads-table-row__delete-button">
                <OKIconButton icon="icon-eliminar" onClick={this.handleDeletePeriodicLoads}/>
            </div>
        );
        return (
            <div>
                <OKTooltip
                    content="cardPeriodicLoads-editButtonTooltip"
                    offset={[0, -15]}
                    target={editButton}
                    type="descriptive"
                />
                <OKTooltip
                    content="cardPeriodicLoads-deleteButtonTooltip"
                    offset={[0, -15]}
                    target={deleteButton}
                    type="descriptive"
                />
            </div>
        );
    }

    render() {
        const {
            id,
            immTransaction,
            isExpanded
        } = this.props;
        const language = getLanguage();
        const currency = formatCurrency(EURO_TEXT);
        const amount = getFormattedString({ amount: immTransaction.get('transferAmount'), currency });
        const toggleClass = classNames('periodic-loads-table-row__toggle--collapse', {
            'periodic-loads-table-row__toggle--expand': isExpanded
        });
        let tableRow = (<div></div>);
        const scheduleType = immTransaction.get('scheduleType');
        const periodicityConcept = immTransaction.get('comment');
        if(immTransaction) {
            const endDate = immTransaction.get('endDate');
            let endDateComponent;
            if(endDate !== DATE_FOR_INFINITE) {
                endDateComponent = (
                    <LabelDate
                        date={endDate}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                );
            }else {
                endDateComponent = <FormattedText value="periodicity-constantly"/>;
            }
            tableRow = (
                <OKTableRow id={id} isExpanded={isExpanded} className="periodic-loads-table-row">
                    <OKTableCell>
                        <OKCollapsingToggler className={toggleClass} handlerToggle={this.onRowClick} isExpanded={isExpanded} isIconSecondary={true} />
                    </OKTableCell>
                    <OKTableCell>
                        <LabelDate
                            date={immTransaction.get('startDate')}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </OKTableCell>
                    <OKTableCell>
                        {endDateComponent}
                    </OKTableCell>
                    <OKTableCell>
                        {formatText(PERIODICITY[scheduleType])}
                    </OKTableCell>
                    <OKTableCell>
                        {periodicityConcept}
                    </OKTableCell>
                    <OKTableCell className="periodic-loads-table-row__amount">
                        {amount}
                    </OKTableCell>
                    <OKTableCell>
                        {this.buildActionButtons()}
                    </OKTableCell>
                </OKTableRow>
            );
        }
        return tableRow;
    }
}

PeriodicLoadsTableRow.propTypes = {
    chore: PropTypes.object,
    id: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    isExpanded: PropTypes.bool,
    onRowClick: PropTypes.func
};
module.exports = withRouter(PeriodicLoadsTableRow);
